type FilteredByLabelProps = {
  label: string;
};

/**
 * The leading "filtered by" marker of the ActiveFilterBar: a small funnel icon
 * followed by the translated label. Presentational only — kept separate so the
 * parent reads as the three-part layout it is: label | chips | actions.
 */
export function FilteredByLabel(props: FilteredByLabelProps) {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-[#0747A6] font-semibold mr-0.5">
      <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 5h18l-7 8v6l-4 2v-8z" />
        </g>
      </svg>
      {props.label}
    </span>
  );
}
